import http from "../http-common";

class AgrupacioEnquestesService {
    listAgrupacions(data) {
        return http.get("/agrupacio/list",data);
    }
    listAgrupacionsBuit(data) {
        return http.get("/agrupacio/list-buit",data);
    }
}

export default new AgrupacioEnquestesService();